exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report[data-v-c6e1269e]{margin-top:30px}.center[data-v-c6e1269e]{text-align:center}.btn-export[data-v-c6e1269e]{text-align:right;margin-bottom:.25rem}.break-word[data-v-c6e1269e]{word-break:break-all}.colour-pdf[data-v-c6e1269e]{color:red}.colour-excel[data-v-c6e1269e]{color:green}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c6e1269e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reportes/materiales/EstadoMateriales.vue
// module id = 270
// module chunks = 58